import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { productAPI } from '../services/api';
import { useCart } from '../context/CartContext';
import {
  FiStar, FiGrid, FiList, FiX, FiChevronDown,
} from 'react-icons/fi';
import './ProductsListPage.css';
import HeroCarousel from './HeroCarousel';
import AvailableSection from './AvailableSection';
import VideoReviewSection from './Videoreviewsection';
import TestimonialSection from './Testimonialsection';
import TrustBar from './trustbar';
import TestimonialMarquee from './Testimonialmarquee';
import WhatsappButton from './whatsappbutton';
import VedonicaFAQ from './Vedonicafaq';
import MarqueeBanner from './Marqueebanner';
import ConsultationCTA from './Consultationcta';




const SORT_OPTIONS = [
  { value: 'popular',    label: 'Most Popular' },
  { value: 'price_asc',  label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'rating',     label: 'Top Rated' },
  { value: 'discount',   label: 'Biggest Discount' },
  { value: 'newest',     label: 'Newest First' },
];

const DEFAULT_PRICE_MAX = 5000;

const getEffectivePrice = (variant) =>
  parseFloat(variant?.effective_price ?? variant?.discounted_price ?? variant?.price ?? 0);

const getOriginalPrice = (variant) =>
  parseFloat(variant?.price ?? 0);

const getMaxDiscount = (variants = []) =>
  Math.max(0, ...variants.map((v) => v.discount_percentage ?? 0));

const getPrimaryImage = (product) =>
  product.images?.find((img) => img.is_primary) || product.images?.[0];

const Stars = ({ rating, size = 12 }) => (
  <div className="plp-stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <FiStar
        key={s}
        size={size}
        className={s <= Math.round(rating) ? 'plp-star plp-star--filled' : 'plp-star'}
      />
    ))}
  </div>
);

const FilterTag = ({ label, onRemove }) => (
  <div className="plp-filter-tag">
    {label}
    <button className="plp-filter-tag__remove" onClick={onRemove} aria-label={`Remove ${label}`}>
      <FiX size={11} />
    </button>
  </div>
);

const ProductCard = ({ product, listView }) => {
  const { addToCart, buyNow } = useCart();
  const [selectedVariant, setSelectedVariant] = useState(product.variants?.[0]);
  const [addingCart, setAddingCart] = useState(false);
  const [addingBuy, setAddingBuy] = useState(false);
 

  // FIX: Build productInfo from current product + variant so price is never 0
  const getProductInfo = () => ({
    productName: product.name,
    packLabel:   selectedVariant?.pack_label || '',
    price:       getEffectivePrice(selectedVariant),
  });

const handleAddToCart = async (e) => {
  e.preventDefault(); e.stopPropagation();
  if (!selectedVariant || addingCart) return;
  setAddingCart(true);
  try {
    await addToCart(selectedVariant.id, 1, getProductInfo());
  } finally {
    setAddingCart(false);
  }
};

const handleBuyNow = async (e) => {
  e.preventDefault(); e.stopPropagation();
  if (!selectedVariant || addingBuy) return;
  setAddingBuy(true);
  try {
    await buyNow(selectedVariant.id, 1, getProductInfo());
  } finally {
    setAddingBuy(false);
  }
};

  const primaryImage = getPrimaryImage(product);
  const effectivePrice = getEffectivePrice(selectedVariant);
  const originalPrice = getOriginalPrice(selectedVariant);
  const discountPct = selectedVariant?.discount_percentage ?? 0;
  const maxDiscount = getMaxDiscount(product.variants);

  return (
    <Link to={`/product/${product.slug}`} className={`plp-card ${listView ? 'plp-card--list' : ''}`}>
      <div className="plp-card__img-wrap">
        {primaryImage?.image_url ? (
          <img src={primaryImage.image_url} alt={product.name} className="plp-card__img" />
        ) : (
          <div className="plp-card__img-placeholder"></div>
        )}
        {discountPct > 0 && <span className="plp-card__badge">{discountPct}% OFF</span>}
        
      </div>

      <div className="plp-card__body">
        <div className="plp-card__category">{product.category?.name ?? 'Ayurvedic Wellness'}</div>
        <h3 className="plp-card__name">{selectedVariant?.name || product.name}</h3>
<p className="plp-card__desc">{selectedVariant?.short_description || product.short_description}</p>

        {product.review_count > 0 && (
          <div className="plp-card__meta">
            <Stars rating={product.average_rating} />
            <span className="plp-card__rating">{product.average_rating}</span>
            <span className="plp-card__reviews">({product.review_count})</span>
          </div>
        )}

        {product.variants?.length > 1 && (
          <div className="plp-card__variants">
            {product.variants.map((v) => (
              <button
                key={v.id}
                className={`plp-card__var-btn ${selectedVariant?.id === v.id ? 'plp-card__var-btn--active' : ''}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedVariant(v); }}
              >
                {v.pack_label}
              </button>
            ))}
          </div>
        )}

        <div className="plp-card__price-row">
          <span className="plp-card__price-new">₹{effectivePrice.toFixed(0)}</span>
          {discountPct > 0 && (
            <>
              <span className="plp-card__price-old">₹{originalPrice.toFixed(0)}</span>
              <span className="plp-card__discount-pill">{discountPct}% off</span>
            </>
          )}
        </div>

        <div className="plp-card__actions">
          <button className="plp-card__cart-btn" onClick={handleAddToCart} disabled={addingCart || addingBuy}>
  {addingCart ? 'Adding…' : 'Add to Cart'}
</button>
<button className="plp-card__buy-btn" onClick={handleBuyNow} disabled={addingBuy || addingCart}>
  {addingBuy ? 'Opening…' : 'Buy Now'}
</button>
          <Link to={`/product/${product.slug}`} className="plp-card__view-btn" onClick={(e) => e.stopPropagation()}>
            View Details
          </Link>
        </div>
      </div>
    </Link>
  );
};


const ProductsListPage = () => {
  const [products, setProducts]               = useState([]);
  const [loading, setLoading]                 = useState(true);

  const [search, setSearch]                   = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceRange, setPriceRange]           = useState([0, DEFAULT_PRICE_MAX]);
  const [minRating, setMinRating]             = useState(0);
  const [minDiscount, setMinDiscount]         = useState(0);
  const [sortBy, setSortBy]                   = useState('popular');
  const [viewMode, setViewMode]               = useState('grid');

  useEffect(() => {
    productAPI.getAll()
      .then((res) => {
        const data = res.data;
        const list = Array.isArray(data) ? data : (Array.isArray(data.results) ? data.results : []);
        setProducts(list.filter((p) => p.is_active));
      })
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const maxPrice = useMemo(() => {
    if (!products.length) return DEFAULT_PRICE_MAX;
    return Math.max(DEFAULT_PRICE_MAX, ...products.flatMap((p) =>
      (p.variants ?? []).map((v) => getOriginalPrice(v))
    ));
  }, [products]);

  const toggleCategory = useCallback((cat) => {
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  }, []);

  const resetFilters = useCallback(() => {
    setSearch('');
    setSelectedCategories([]);
    setPriceRange([0, maxPrice]);
    setMinRating(0);
    setMinDiscount(0);
    setSortBy('popular');
  }, [maxPrice]);

  const filteredProducts = useMemo(() => {
    let list = products.filter((p) => {
      const q = search.toLowerCase();
      if (q && !p.name.toLowerCase().includes(q) && !(p.short_description ?? '').toLowerCase().includes(q)) return false;
      if (selectedCategories.length) {
        if (!selectedCategories.includes(p.category?.name ?? '')) return false;
      }
      const price = getEffectivePrice(p.variants?.[0]);
      if (price < priceRange[0] || price > priceRange[1]) return false;
      if (minRating > 0 && (p.average_rating ?? 0) < minRating) return false;
      if (minDiscount > 0 && getMaxDiscount(p.variants) < minDiscount) return false;
      return true;
    });

    switch (sortBy) {
      case 'price_asc':  list = [...list].sort((a, b) => getEffectivePrice(a.variants?.[0]) - getEffectivePrice(b.variants?.[0])); break;
      case 'price_desc': list = [...list].sort((a, b) => getEffectivePrice(b.variants?.[0]) - getEffectivePrice(a.variants?.[0])); break;
      case 'rating':     list = [...list].sort((a, b) => (b.average_rating ?? 0) - (a.average_rating ?? 0)); break;
      case 'discount':   list = [...list].sort((a, b) => getMaxDiscount(b.variants) - getMaxDiscount(a.variants)); break;
      case 'newest':     list = [...list].sort((a, b) => b.id - a.id); break;
      default: break;
    }
    return list;
  }, [products, search, selectedCategories, priceRange, minRating, minDiscount, sortBy]);

  const activeTags = useMemo(() => {
    const tags = [];
    if (search)                tags.push({ label: `"${search}"`,                    onRemove: () => setSearch('') });
    selectedCategories.forEach((c) => tags.push({ label: c,                         onRemove: () => toggleCategory(c) }));
    
    if (minRating > 0)         tags.push({ label: `${minRating}★+`,                 onRemove: () => setMinRating(0) });
    if (minDiscount > 0)       tags.push({ label: `${minDiscount}%+ off`,           onRemove: () => setMinDiscount(0) });
    return tags;
  }, [search, selectedCategories, priceRange, maxPrice, minRating, minDiscount, toggleCategory]);

  return (
    <>
      <Helmet>
        <title>Shop – Vedonica International | Pure Ayurvedic Wellness</title>
        <meta name="description" content="Discover Vedonica's premium Ayurvedic wellness oils. 100% natural, cold-pressed, crafted for radiant skin and holistic wellness." />
      </Helmet>

     <HeroCarousel />

<div className="sr-only">
  <h1>India's No 1 Fat Burner</h1>
  <h2>Naturally Radiant Skin, Stronger with Vedonica</h2>
</div>

<div className="plp-container plp-body">
        <div className="plp-content">
          <div className="plp-toolbar">
            <span className="plp-toolbar__count">
              {loading ? 'Loading…' : `${filteredProducts.length} product${filteredProducts.length !== 1 ? 's' : ''}`}
            </span>

            <div className="plp-toolbar__right">
              <div className="plp-sort-wrap">
                <select className="plp-sort-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                  {SORT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
                <FiChevronDown className="plp-sort-chevron" size={13} />
              </div>

              <div className="plp-view-toggle">
                <button className={`plp-view-btn ${viewMode === 'grid' ? 'plp-view-btn--active' : ''}`} onClick={() => setViewMode('grid')} aria-label="Grid view">
                  <FiGrid size={15} />
                </button>
                <button className={`plp-view-btn ${viewMode === 'list' ? 'plp-view-btn--active' : ''}`} onClick={() => setViewMode('list')} aria-label="List view">
                  <FiList size={15} />
                </button>
              </div>
            </div>
          </div>

          {activeTags.length > 0 && (
            <div className="plp-active-tags">
              {activeTags.map((t, i) => <FilterTag key={i} label={t.label} onRemove={t.onRemove} />)}
              <button className="plp-active-tags__clear-all" onClick={resetFilters}>Clear all</button>
            </div>
          )}

          {loading ? (
            <div className="plp-loading"><div className="plp-spinner" /></div>
          ) : filteredProducts.length === 0 ? (
            <div className="plp-empty">
              <span className="plp-empty__icon"></span>
              <h3>No products found</h3>
              <p>Try adjusting or clearing your filters.</p>
              <button className="plp-empty__reset-btn" onClick={resetFilters}>Reset filters</button>
            </div>
          ) : (
            <div className={`plp-grid ${viewMode === 'list' ? 'plp-grid--list' : ''}`}>
              {filteredProducts.map((product, i) => (
                <div key={product.id} className="plp-grid__item" style={{ animationDelay: `${Math.min(i * 0.05, 0.4)}s` }}>
                  <ProductCard product={product} listView={viewMode === 'list'} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <MarqueeBanner />
      <VideoReviewSection />
      <TrustBar />
      <TestimonialMarquee />
      <AvailableSection />
      <TestimonialSection />
      <ConsultationCTA />
      <VedonicaFAQ />
      <WhatsappButton /> 
            <MarqueeBanner />

      
      
      

     
    </>
  );
};

export default ProductsListPage;